import $ from 'jquery';
import service from '../ajax/service';
import '../scss/article.scss';
import * as report from "./dataReport";
import { initGameInfo } from "./download";
const id = window.getParam('id');
service.getArticleDetail(id).then(res => {
  $('.j-article-detail-title').html(res.data.TITLE);
  $('.j-time').html(res.data.PUBLISH_TIME.slice(0, 10));
  $('.j-article-content').html(res.data.CONTENT);
});
$('.j-social-btn').on('click', () => {
  $('.j-social-popup').fadeIn(400);
});
$('.j-close,.j-mask').on('click', function () {
  $('.j-popup').fadeOut(500);
});
$('.j-copyright').on('click', () => {
  $('.j-footer').toggleClass('active');
});
$('.j-return').on('click', () => {
  let isGuidetro = window.location.href.indexOf('guidetro') !== -1;
  window.open(isGuidetro ? `https://blancozone.com/frxx/guidetro_m.html` :  `https://blancozone.com/frxx/list_m.html`, '_self');
});
window.getParam('type') === 'guidetro' && $('.j-body').addClass('guidetro');
window.addEventListener('load', () => {
  report.initReport();
  report.commonUpload('文章id',id)
  initGameInfo();
})